export default "__VITE_ASSET__ced41484__"